import { useMediaQuery } from 'react-responsive';

export const useDesktopMediaQuery = () => useMediaQuery({ minWidth: 768 });
